import {
  useGetTotemSystemQuery,
  useGetTotemSystemLimitedQuery,
  type Instacart_Infra_Totem_V1_System,
} from '../../__codegen__/api'
import { useCurrentTotemEntity } from './TotemEntityProvider'

export const useTotem = (params: { hasFullTotemViewAccess?: boolean }) => {
  const hasFullTotemViewAccess = params.hasFullTotemViewAccess
  const { entity, loading: entityLoading, error: entityError } = useCurrentTotemEntity()

  const systemName = entity?.system_name

  const {
    data: fullSystemData,
    loading: fullSystemLoading,
    error: fullSystemError,
  } = useGetTotemSystemQuery({
    // @ts-expect-error TS2322 — strictNullChecks. TODO: fix strict null check
    variables: { systemName },
    skip: !systemName || !hasFullTotemViewAccess,
  })

  const {
    data: limitedSystemData,
    loading: limitedSystemLoading,
    error: limitedSystemError,
  } = useGetTotemSystemLimitedQuery({
    // @ts-expect-error TS2322 — strictNullChecks. TODO: fix strict null check
    variables: { systemName },
    skip: !systemName || hasFullTotemViewAccess,
  })

  const systemData = hasFullTotemViewAccess ? fullSystemData : limitedSystemData

  return {
    data: systemData?.instacart_infra_totem_v1_TotemService_GetSystem
      ?.system as Instacart_Infra_Totem_V1_System,
    loading: entityLoading || (hasFullTotemViewAccess ? fullSystemLoading : limitedSystemLoading),
    error: entityError || (hasFullTotemViewAccess ? fullSystemError : limitedSystemError),
  }
}
